import { choicesFromEnum } from "../../@helpers/choices-from-enum";

export enum userState{
  ACTIVE='active',
  CLOSED='closed',
  SUSPENDED='suspended',
}

export const userStateChoices = choicesFromEnum(userState);